import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_FARE_CONDITIONS_STORE_NAME, GetFareConditionsState } from './get-fare-conditions.state';

/** Select GetFareConditions State */
export const selectGetFareConditionsState =
  createFeatureSelector<GetFareConditionsState>(GET_FARE_CONDITIONS_STORE_NAME);

/** Select GetFareConditions isPending status */
export const selectGetFareConditionsIsPendingStatus = createSelector(
  selectGetFareConditionsState,
  (state) => !!state.isPending
);

/** Select GetFareConditions isFailure status */
export const selectGetFareConditionsIsFailureStatus = createSelector(
  selectGetFareConditionsState,
  (state) => !!state.isFailure
);
